import { useState } from "react";
import { useForm } from "react-hook-form";
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
  InputGroup,
  InputRightElement,
  Box,
  VStack,
  Text,
  Flex,
  useToast
} from "@chakra-ui/react";
import { ArrowForwardIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types'; 
import authServices from "services/authServices";
import Auth from "utils/auth";
import { paths } from "Routes/paths";


const LoginForm = ({toggleAuthState}) => {
  const toast = useToast()
  const navigate = useNavigate()
 
  const { mutate : login, isLoading } = useMutation(authServices.login, {
    onSuccess: ({data}) => {
      Auth.setToken(data?.accessToken)
      Auth.setRefreshToken(data?.refreshToken)
      navigate(paths.SELECT_FAVOURITES)
    },
    onError: ({message}) => {
      toast({
        title: 'Error',
        description: message,
        status: 'error',
        duration: 9000,
        isClosable: true,
        position: 'top-right'
      })
    }
  })
  
  const onSubmit = (values) => {
    login({...values})
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={4}>
        <FormControl isInvalid={errors.email}>
          <FormLabel fontWeight="bold" htmlFor="email">Email</FormLabel>
          <Input
            size="lg"
            id="email"
            placeholder="example@mail.com"
            focusBorderColor="brand.primary"
            {...register("email", {
              required: "Email is required",
            })}
          />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={errors.email}>
          <FormLabel fontWeight="bold" htmlFor="password">Password</FormLabel>
          <InputGroup size="lg">
            <Input
              size="lg"
              id="password"
              placeholder="********"
              type={showPassword ? "text" : "password"}
              focusBorderColor="brand.primary"
              {...register("password", {
                required: "password is required",
              })}
            />
            <InputRightElement width="4.5rem">
              <Box type="button" as="button" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <ViewOffIcon /> : <ViewIcon />}
              </Box>
            </InputRightElement>
          </InputGroup>
          <FormErrorMessage>
            {errors.password && errors.password.message}
          </FormErrorMessage>
        </FormControl>
        </VStack>
        <Flex justify="flex-end" mt={5}>
             <Text fontSize={{base: 14, md: 16}} mr={2} align="right" color="brand.primary">Don't have an account? </Text>
             <Button disabled={isLoading} fontSize={{base: 14, md: 16}} onClick={() => toggleAuthState()} _focus={{boxShadow: 0}} color="brand.primary" variant="link">Sign up</Button>
            </Flex>
        <Box display="flex" justifyContent="flex-end">
        <Button isLoading={isLoading} loadingText="Hold on" size="lg" rightIcon={<ArrowForwardIcon/>} mt={6} bg="brand.lightYellow" type="submit">
          Login
        </Button>
        </Box>
      </form>
    </Box>
  );
};

LoginForm.propTypes = {
    toggleAuthState: PropTypes.func
}

export default LoginForm;
